export default __webpack_public_path__ + "static/media/2.9c290c3d.jpg";